import { render } from "./settings_modal.vue?vue&type=template&id=158fe39d"
import script from "./settings_modal.js?vue&type=script&lang=js"
export * from "./settings_modal.js?vue&type=script&lang=js"

import "./settings_modal.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__